// extracted by mini-css-extract-plugin
export default {"backButton":"wvcDTVnCWv","title":"V7dYhoYMq9"};